import { createReducer, on } from '@ngrx/store'
import { unauthorizedUser } from '@adex/store/actions'
import { IFinanceOverviewState } from '@adex/shared/models/states/finance.state'
import { setFinanceOverviewState, setSubscriptionsInfoState, setSubscriptionsTypeState } from '@adex/store/actions/finance.actions'


const initialState: IFinanceOverviewState = {}

export const financeOverviewReducer = createReducer(
  initialState,
  on(unauthorizedUser, () => ({ ...initialState })),
  on(setFinanceOverviewState, (state, { state: newState }) => ({ ...state, ...newState })),
  on(setSubscriptionsTypeState, (state, { state: subscriptions }) => ({ ...state, subscriptions })),
  on(setSubscriptionsInfoState, (state, { state: subscriptionInfo }) => ({ ...state, subscriptionInfo }))
)
